import { create } from "zustand";
import { devtools, persist } from "zustand/middleware";

export const useAuthPersistedStore = create()(
  devtools(
    persist(
      (set) => ({
        isLoggedIn: false,
        setIsLoggedIn: (isLoggedIn) => {
          set({ isLoggedIn });
        },
      }),
      {
        name: "auth-store",
      }
    )
  )
);
